import { useMediaQuery } from "@mui/material";
import { FC, useContext } from "react";

import { Select } from "../../../components/OldSelect";
import Switch from "../../../components/Switch";
import Text from "../../../components/Text";
import { AuthContext } from "../../../contexts/AuthContext";
import { useThemeMode } from "../../../contexts/ThemeContext";
import { usePerformanceVisibility } from "../../../hooks/usePerformanceVisibility";
import styles from "./styles.module.scss";

const SWITCH_COLORS = {
    on: "#00B69C",
    off: "#8b95a7",
    thumb: "#fff",
};

type Props = {
    handleTabChange: (key: string) => void;
};

const Affichage: FC<Props> = ({ handleTabChange }) => {
    const isMobile = useMediaQuery("(max-width: 1050px)");
    const { user } = useContext(AuthContext)!;
    const { isDarkMode, toggleTheme } = useThemeMode();
    const { hidePerformance, setHidePerformance } =
        usePerformanceVisibility(user?.id);

    return (
        <div className={styles.form}>
            <div className={styles.header}>
                {isMobile ? (
                    <Select
                        value="affichage"
                        className={styles.selectTab}
                        onChanged={(value) => {
                            const key = value as string;
                            handleTabChange(key === "profil" ? "" : key);
                        }}
                    >
                        <option value="profil">Profil</option>
                        <option value="questions">Informations</option>
                        <option value="affichage">Affichage</option>
                    </Select>
                ) : (
                    <span className={styles.form_header}>Affichage</span>
                )}
            </div>

            <div className={styles.sections}>
                <div className={styles.section}>
                    <div className={styles.settingRow}>
                        <Text variant="body-bold">Afficher les performances</Text>
                        <Switch
                            checked={!hidePerformance}
                            onChange={(show) => setHidePerformance(!show)}
                            ariaLabel="Afficher ou masquer les performances"
                            colors={SWITCH_COLORS}
                        />
                    </div>

                    <div className={styles.settingRow}>
                        <Text variant="body-bold">Mode sombre</Text>
                        <div className={styles.themeSwitch}>
                            <Switch
                                checked={isDarkMode}
                                onChange={toggleTheme}
                                ariaLabel="Activer ou désactiver le mode sombre"
                                colors={SWITCH_COLORS}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Affichage;
